import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useShop } from "@/lib/shop";

const WhatsAppButton = () => {
  const shop = useShop();
  const digits = (shop.whatsapp || "").replace(/\D/g, "");
  if (!digits) return null;

  const href = `https://wa.me/${digits}?text=${encodeURIComponent("Bonjour Sama-Keur, je souhaite passer une commande ou poser une question.")}`;

  return (
    <motion.a
      data-testid="whatsapp-floating-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.1, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-bark/25"
      aria-label="Commander par WhatsApp"
    >
      <span className="pointer-events-none absolute right-[4.5rem] whitespace-nowrap rounded-full bg-bark px-4 py-2 text-xs font-semibold text-sand opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        Commander par WhatsApp
      </span>
      <MessageCircle className="h-7 w-7" fill="currentColor" />
      <span className="absolute -right-1 -top-1 flex h-4 w-4">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-60" />
        <span className="relative inline-flex h-4 w-4 rounded-full border-2 border-sand bg-[#25D366]" />
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
